import styled from 'styled-components'
import { theme } from '../../../styles/theme'
import { mq } from '../../../styles/mq'

export const Answer = styled.div<{ $dir: string }>`
  margin: auto;
  width: 100%;
  height: 100%;
  max-width: 1720px;
  transition: opacity 0.5s;
  background: ${theme.colors.background};

  display: block;
  ${mq.medium} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  h3 {
    text-align: center;
    display: none;
    ${mq.medium} {
      display: block;
    }
  }
  > div {
    display: block;

    ${mq.medium} {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4rem;
      flex-direction: ${(props) =>
        props.$dir === 'right' ? 'row' : 'row-reverse'};

      &::before {
        content: '';
        display: block;
        width: 5%;
        flex-shrink: 0;
      }
    }

    img {
      transform: ${(props) => (props.$dir === 'left' ? 'scaleX(-100%)' : '')};
      width: 100%;
      mix-blend-mode: darken;

      ${mq.medium} {
        width: 28%;
        flex-shrink: 0;
      }
    }
  }
`

export const Bubble = styled.div<{ $dir: string }>`
  position: relative;
  width: calc(72% - 40px);
  ${mq.smallOnly} {
    font-size: 1.5rem;
  }
  ${mq.medium} {
    font-size: 1.6rem;
  }
  ${mq.large} {
    font-size: 1.9rem;
  }
  ${mq.xlarge} {
    font-size: 2.1rem;
  }
  font-family: 'skolar-latin', serif;
  font-style: italic;
  ${(props) =>
    props.$dir === 'right' ? 'margin-left:40px' : 'margin-right: 40px'};

  left: 0;
  right: 0;
  border-radius: 0;
  background: white;
  margin: 0;
  width: 100%;
  border: none;
  border-bottom: 1px solid ${theme.colors.text};
  border-top: 1px solid ${theme.colors.text};
  padding: 1.2rem 2rem;
  ${mq.medium} {
    left: auto;
    right: auto;
    border: 1px solid ${theme.colors.text};
    border-radius: 30px;
    background: ${theme.colors.background};
  }

  ${mq.medium} {
    padding: ${(props) =>
      props.$dir === 'right' ? '16px 60px 16px 80px;' : '16px 80px 16px 60px;'};
  }
  ${mq.large} {
    padding: ${(props) =>
      props.$dir === 'right'
        ? '20px 120px 20px 150px;'
        : '20px 150px 20px 120px;'};
  }
  ${mq.xlarge} {
    padding: ${(props) =>
      props.$dir === 'right'
        ? '20px 150px 20px 180px;'
        : '20px 180px 20px 150px;'};
  }
  span {
    display: block;
    ${mq.smallOnly} {
      font-size: 1.7rem;
    }
    ${mq.medium} {
      font-size: 2.1rem;
    }
    ${mq.large} {
      font-size: 2.6rem;
    }
    ${mq.xlarge} {
      font-size: 3rem;
    }
    margin-top: 2rem;
    font-weight: 800;
    font-style: normal;
    font-family: 'Skolar Sans PE Condensed', sans-serif;
  }
  svg.horizontal {
    position: absolute;
    ${(props) =>
      props.$dir === 'right'
        ? 'left:calc(100% - 1px)'
        : 'right: calc( 100% - 1px)'};
    top: 50%;
    transform: translateY(-50%);
    display: none;
    ${mq.medium} {
      display: block;
      width: 56px;
    }
    ${mq.large} {
      width: 76px;
    }
    ${mq.xlarge} {
      width: 96px;
    }
  }
  svg.vertical {
    position: absolute;
    top: 100%;
    left: 85%;
    width: 32px;
    ${mq.medium} {
      display: none;
    }
  }
`
